export default __webpack_public_path__ + "static/817-5e31598a5cc1b6086100930e1fd38ed8.gif";